module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/chocolate@3x_d02fd8.jpg";